import { Injectable, Output, EventEmitter } from "@angular/core";
import { UrlData } from "@app/interfaces/UrlData";



@Injectable({ providedIn: 'root' })
export class UrlDataService {

    @Output() urlParsed : EventEmitter<any> = new EventEmitter<any>()
    // private _urlData = new Subject();
   // urlData$ = this._urlData.asObservable();

    constructor() {
    }
    setUrlData(data: any) {
        this.urlParsed.emit(data)
        // if (data.guestStayUuid && data.hotel3pId) {
        //     this._urlData.next(data)
        // } else {
        //     const ret : UrlData = {guestStayUuid:'',hotel3pId:'',invite: ''}
        //     this._urlData.next(ret);
        // }
    }
}